<mat-toolbar class="fixed-top custom-navbar" color="primary">
  <!-- menu desktop -->
  <mat-toolbar-row class="flex nav-desktop d-none d-lg-flex shadow-lo">
    <span class="stretch">
      <a class="navbar-brand">
        <img *ngIf="theme === 'Redtrust'" src="assets/images/logo/{{theme}}/logo-white.svg" height="25" class="d-inline-block align-top me-3" [alt]="'NAVBAR.LOGOS.REDTRUST-ALT' | translate:{ theme: theme }">
    </a>
    </span>

    <span style="height: 100%;">
      <button mat-button *ngIf="hasWebSignAccess" routerLinkActive="active" [routerLink]="angularPaths.SIGNTRUST">{{ 'NAVBAR.PAGES.WEB-SIGN.TITLE' | translate }}</button>
      <button mat-button *ngIf="hasCertificatesAccess" routerLinkActive="active" [routerLink]="angularPaths.CERTIFICATES">{{ 'NAVBAR.PAGES.CERTIFICATES.TITLE' | translate }}</button>
    </span>

    <div class="auto-spacer"></div>

    <button mat-button [matMenuTriggerFor]="userMenu" class="profile-button">
      <i class="rt-icon rt-usuario fs30"></i>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before" yPosition="below" class="profile-menu" [overlapTrigger]="false">
      <div class="profile-menu-info">
        <span class="profile-menu-info-icon">
          <i class="rt-icon rt-usuario-11 fs22 me-2"></i>
        </span>
        <span class="profile-menu-info-label">
          <span class="fw-bolder text-ellipsis-1 pe-1" [matTooltip]="userData?.friendlyName.length <= 28 ? null : userData?.friendlyName">
            {{ userData?.friendlyName.length > 28 ? (userData?.friendlyName | slice: 0:28) + '...' : userData?.friendlyName }}
          </span>
          <span class="font-italic one-line-text font-small text-ellipsis-1 pe-1" [matTooltip]="userData?.email.length <= 25 ? null : userData?.email">
            {{ userData?.email.length > 25 ? (userData?.email | slice: 0:25) + '...' : userData?.email }}
          </span>
        </span>
      </div>

      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openUserProfile();">
        <i class="rt-icon rt-personalizar fs22 me-2"></i>
        <span >{{ 'NAVBAR.PAGES.EDIT-ACCOUNT.TITLE' | translate }}</span>
      </button>
      <mat-divider></mat-divider>

      <button mat-menu-item (click)="onLogout()">
        <i class="rt-icon rt-exit-1 fs22 me-2"></i>
        <span> {{ 'NAVBAR.PAGES.LOGOUT.TITLE' | translate }}</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>

  <!-- menu mobile -->
  <mat-toolbar-row class="flex nav-mobile d-lg-none shadow-mid">
    <button mat-button class="btn-menu-mobile" *ngIf="!navOpen" (click)="navOpen=!navOpen">
      <!-- <mat-icon style="margin-right: 0;">menu</mat-icon> -->
      <i class="rt-icon rt-fill-menu-4 fs25"></i>
    </button>
    <button mat-button class="btn-menu-mobile" *ngIf="navOpen" (click)="navOpen=!navOpen">
      <!-- <mat-icon style="margin-right: 0;">close</mat-icon> -->
      <i class="rt-icon rt-multiply fs25"></i>
    </button>

    <span class="stretch">
      <a class="navbar-brand mx-0">
        <img *ngIf="theme === 'Redtrust'" src="assets/images/logo/{{theme}}/logo-white.svg" height="25" class="d-inline-block align-top" [alt]="'NAVBAR.LOGOS.REDTRUST-ALT' | translate:{ theme: theme }">
      </a>
    </span>

    <button mat-button [matMenuTriggerFor]="userMenu" class="profile-button">
      <i class="rt-icon rt-usuario fs30"></i>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before" yPosition="below" class="profile-menu" [overlapTrigger]="false">
      <div class="profile-menu-info">
        <span class="profile-menu-info-icon">
          <i class="rt-icon rt-usuario-11 fs22 me-2"></i>
        </span>
        <span class="profile-menu-info-label">
          <span class="fw-bolder text-ellipsis-1 pe-1" [matTooltip]="userData?.friendlyName.length <= 28 ? null : userData?.friendlyName">
            {{ userData?.friendlyName.length > 28 ? (userData?.friendlyName | slice: 0:28) + '...' : userData?.friendlyName }}
          </span>
          <span class="font-italic one-line-text font-small text-ellipsis-1 pe-1" [matTooltip]="userData?.email.length <= 25 ? null : userData?.email">
            {{ userData?.email.length > 25 ? (userData?.email | slice: 0:25) + '...' : userData?.email }}
          </span>
        </span>
      </div>

      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openUserProfile();">
        <i class="rt-icon rt-personalizar fs22 me-2"></i>
        <span >{{ 'NAVBAR.PAGES.EDIT-ACCOUNT.TITLE' | translate }}</span>
      </button>
      <mat-divider></mat-divider>

      <button mat-menu-item (click)="onLogout()">
        <i class="rt-icon rt-exit-1 fs22 me-2"></i>
        <span> {{ 'NAVBAR.PAGES.LOGOUT.TITLE' | translate }}</span>
      </button>
    </mat-menu>

    <div class="mobile-menubox animated fadeInLeft shadow-mid" *ngIf="navOpen">
      <a *ngIf="hasWebSignAccess" class="w-100 p-2 bg-white text-center d-block text-danger" (click)="navOpen=!navOpen" routerLinkActive="active" [routerLink]="angularPaths.SIGNTRUST">{{ 'NAVBAR.PAGES.WEB-SIGN.TITLE' | translate }}</a>
      <a *ngIf="hasCertificatesAccess" class="w-100 p-2 bg-white text-center d-block text-danger" (click)="navOpen=!navOpen" routerLinkActive="active" [routerLink]="angularPaths.CERTIFICATES">{{ 'NAVBAR.PAGES.CERTIFICATES.TITLE' | translate }}</a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
